// @flow

import React from 'react';
import type { Coordinate } from './types';
import { ADMIN_ICON_SIZE } from './Admin/index';

type Props = {
  picture: Image,
  coordinate: Coordinate,
  iconid: string,
};

export default class CoordinateIcon extends React.PureComponent<Props> {
  iconRef: Object;
  resizeEvent: Event;
  constructor(props: Props): void {
    super(props);
    this.iconRef = React.createRef();
  }

  updateBackgroundPosition = () => {
    if (this.iconRef.current) {
      const imRect = this.iconRef.current.getBoundingClientRect();
      const iconScaleX = imRect.width / (ADMIN_ICON_SIZE + 10);
      const iconScaleY = imRect.height / (ADMIN_ICON_SIZE + 10);
      const posX = (this.props.coordinate.x * iconScaleX) - (imRect.width / 2);
      const posY = (this.props.coordinate.y * iconScaleY) - (imRect.height / 2);
      this.iconRef.current.style.transition = 'all 0ms';
      this.iconRef.current.style.opacity = '1';
      this.iconRef.current.style.backgroundPosition = `-${posX + (this.props.picture.width * iconScaleX)}px -${posY + (this.props.picture.height * iconScaleY)}px`;
      this.iconRef.current.style.backgroundSize = `${this.props.picture.width * iconScaleX}px ${this.props.picture.height * iconScaleY}px`;
    }
  }

  componentDidUpdate = (prevProps: Props) => {
    if (this.props !== prevProps) {
      this.updateBackgroundPosition();
    }
  }

  componentDidMount = () => {
    if (this.iconRef) {
      this.updateBackgroundPosition();
      this.resizeEvent = window.addEventListener('resize', () => { this.updateBackgroundPosition(); });
    }
  }

  render(): React$Element<any> {
    return (
      <div className="h-12 w-12 md:h-20 md:w-20 my-2">
        <div
          id={this.props.iconid}
          ref={this.iconRef}
          className="w-full h-full opacity-1"
          style={{
            backgroundImage: `url('${this.props.picture.src}')`,
            backgroundRepeat: 'repeat',
            backgroundOrigin: 'border-box',
          }}
        />
      </div>
    );
  }
}
